<template>
    <i :class="classes" @click="toggle"></i>
    <!--<button type="submit" >
        <span class="glyphicon glyphicon-heart"></span>
    </button>-->

</template>

<script>
    export default {
        name: "FavoriteSession",
        computed: {
            classes() {
                return [
                    'fa-heart',
                    this.active ? 'fas' : 'far'
                ];
            },

            endpoint() {
                return '/session/' + this.session.id + '/favorite';
            }
        },
        props:
            {
                session: {
                    type: Object,
                    required: true
                },
                isFavorited: {
                    default: false
                }

            },

        data() {
            return {
                active: this.isFavorited
            }
        },

        methods: {
            toggle() {
                this.active ? this.destroy() : this.create();
            },

            create() {
                axios.post(this.endpoint);

                this.active = true;
                this.count++;
            },

            destroy() {
                axios.delete(this.endpoint);

                this.active = false;
                this.count--;
            }
        },

        beforeCreate() {

        },
        created() {

        },
        beforeMount() {

        },
        mounted() {

        },
        beforeUpdate() {

        },
        updated() {

        },
        beforeDestroy() {

        },
        destroyed() {

        }


    };
</script>

<style scoped>
    i {
        cursor: pointer;
        color: #e74444;
        font-size: 0.7em;
    }
</style>